export const commonRu = {
  search: "Поиск",
  status: "Статус",
  active: "Активен",
  inactive: "Неактивен",
  save: "Сохранить",
  cancel: "Отмена",
  type: "Тип",
  level: "Уровень",
  phrase: "Фраза",
  filename: "Файл",
  image: "Обложка",
  background: "Фон карточки",
  textColor: "Цвет текста",
  upload: "Загрузить",
  replace: "Заменить",
  uploading: "Загрузка…",
  delete: "Удалить",
  noFile: "Нет файла",
  fileUploaded: "Файл загружен",
  uploadError: "Ошибка загрузки",
  fileUploadHint: "Выберите файл — он сохранится в файловом сервисе",
  requiredField: "Обязательное поле",
  userId: "ID пользователя",
  createdAt: "Дата создания",
};

export const commonEn = {
  search: "Search",
  status: "Status",
  active: "Active",
  inactive: "Inactive",
  save: "Save",
  cancel: "Cancel",
  type: "Type",
  level: "Level",
  phrase: "Phrase",
  filename: "File",
  image: "Cover",
  background: "Card background",
  textColor: "Text color",
  upload: "Upload",
  replace: "Replace",
  uploading: "Uploading…",
  delete: "Delete",
  noFile: "No file",
  fileUploaded: "File uploaded",
  uploadError: "Upload failed",
  fileUploadHint: "Pick a file — it will be stored in the file service",
  requiredField: "Required",
  userId: "User ID",
  createdAt: "Created at",
};

export const commonAz = {
  search: "Axtarış",
  status: "Status",
  active: "Aktiv",
  inactive: "Qeyri-aktiv",
  save: "Saxla",
  cancel: "Ləğv et",
  type: "Növ",
  level: "Səviyyə",
  phrase: "İfadə",
  filename: "Fayl",
  image: "Örtük",
  background: "Kart fonu",
  textColor: "Mətn rəngi",
  upload: "Yüklə",
  replace: "Dəyiş",
  uploading: "Yüklənir…",
  delete: "Sil",
  noFile: "Fayl yoxdur",
  fileUploaded: "Fayl yükləndi",
  uploadError: "Yükləmə xətası",
  fileUploadHint: "Fayl seçin — fayl serverində saxlanılacaq",
  requiredField: "Məcburi",
  userId: "İstifadəçi ID",
  createdAt: "Yaradılma tarixi",
};

export const fieldsRu = {
  phraseAz: "Фраза (AZ)",
  phraseRu: "Фраза (RU)",
  phraseEn: "Фраза (EN)",
  titleAz: "Название (AZ)",
  titleRu: "Название (RU)",
  titleEn: "Название (EN)",
  descriptionAz: "Описание (AZ)",
  descriptionRu: "Описание (RU)",
  descriptionEn: "Описание (EN)",
  emotionInsight: "Инсайт",
  preventionPlan: "План профилактики",
  alternativeResponse: "Альтернативная реакция",
};

export const fieldsEn = {
  phraseAz: "Phrase (AZ)",
  phraseRu: "Phrase (RU)",
  phraseEn: "Phrase (EN)",
  titleAz: "Title (AZ)",
  titleRu: "Title (RU)",
  titleEn: "Title (EN)",
  descriptionAz: "Description (AZ)",
  descriptionRu: "Description (RU)",
  descriptionEn: "Description (EN)",
  emotionInsight: "Insight",
  preventionPlan: "Prevention plan",
  alternativeResponse: "Alternative response",
};

export const fieldsAz = {
  phraseAz: "İfadə (AZ)",
  phraseRu: "İfadə (RU)",
  phraseEn: "İfadə (EN)",
  titleAz: "Başlıq (AZ)",
  titleRu: "Başlıq (RU)",
  titleEn: "Başlıq (EN)",
  descriptionAz: "Təsvir (AZ)",
  descriptionRu: "Təsvir (RU)",
  descriptionEn: "Təsvir (EN)",
  emotionInsight: "İnsayt",
  preventionPlan: "Profilaktika planı",
  alternativeResponse: "Alternativ reaksiya",
};
